export default {
    "general.knowYourLoan.header": "know your loan. love your lender.",
    "general.knowYourLoan.paragraph": "from home ownership to home innovation, we drive modern lending forward with fast, tech-enabled financing solutions."  
}